import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkPermission, Constants } from 'utils';

const Reports = () => {
	if (checkPermission(Constants.MODULES.REPORTS,'read')) {
		return <Redirect to="/admin/reports/services" />
	}

	return null;
}

export default Reports;